import axios from 'axios'
import router from './router/index'
import store from './store/index'
import * as types from './store/types'

//
axios.default.timeout = 5000
axios.defaults.headers.post['Content-Type'] = 'application/json'

const instance = axios.create();
instance.defaults.headers.post['Content-Type'] = 'application/json'

axios.interceptors.request.use = instance.interceptors.request.use
instance.interceptors.request.use(config => {
	if(localStorage.getItem('token')) {
		config.headers.Authorization = `token ${localStorage.getItem('token')}`
			.replace(/(^\")|(\"$)/g, '')
	}
	return config
}, err => {
	return Promise.reject(err)
})
// axios拦截响应
instance.interceptors.response.use(response => {
	return response
}, err => {
	return Promise.reject(err)
})

export default {
	// 用户注册
	userRegister(data) {
		return instance.post('/api/register', data)
	},
	// 用户登录
	UserLogin(data) {
		return instance.post('/api/login', data)
	},
	// 获取用户
	getUser() {
		return instance.get('/api/user')
	},
	// 删除用户
	delUser(data) {
		return instance.post('/api/delUser', data)
	},
	upload(data) {
		return instance.post('/api/upload/file', data)
	},	
	getUploadList(){
		return instance.get('/api/uploadList')
	},
	UserDesignSubmit(data){
		return instance.post('/api/userDesignSubmit', data)
	},
	getDesignIdList(params){
		return instance.get('/api/designList',{params})
	},
	UserAnalysisSubmit(data){
		return instance.post('/api/userAnalysisSubmit',data)
	},
	getTaskList(params){
		return instance.get('/api/getTaskList',{params})
	},
	download(data){
		return instance.post('/api/download',data,{responseType:'blob'})
	},
	getDesignedSourceList(params){
		return instance.get('/api/getDesignedSourceList',{params})
	},
	getGeneGroupList(params){
		return instance.get('/api/getGeneGroupList',{params})
	},
	activateAccount(params){
		return instance.get('/api/activate',{params})
	},
	sendVerificationCode(params){
		return instance.get('/api/sendVerificationCode',{params})
	},
	resetPassword(data){
		return instance.post('/api/resetPassword',data)
	},
	deleteDesignTask(data){
		return instance.post('/api/deleteDesign',data)
	},
	deleteAnalysisTask(data){
		return instance.post('/api/deleteAnalysis',data)
	},
}



// WEBPACK FOOTER //
// ./src/axios.js